import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { usePrevious } from '#/hooks/usePrevious';
import { identifyWalletInPosthog } from '#/lib/analyticsPosthogSetup';
import { useSelector } from '#/reduxState/store';

function QueryWalletBackgroundObserver() {
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const prevWalletAddress = usePrevious(walletAddress);
  const queryClient = useQueryClient();

  /** Reset analytics identifier on wallet change */
  useEffect(() => {
    identifyWalletInPosthog(walletAddress || undefined);
  }, [walletAddress]);

  /* We monitor the wallet address as it might change and properly remove
     cache state and cancel queries that may be in flight for a wallet 
     address. */
  useEffect(() => {
    if (prevWalletAddress && prevWalletAddress !== walletAddress) {
      // remove all queries from cache with the old wallet and
      // cancel any inflight queries
      queryClient.removeQueries({
        predicate: query => {
          // remove all queries with wallet address in the query key
          return query.queryKey.includes(prevWalletAddress);
        },
      });
    }
  }, [walletAddress, prevWalletAddress, queryClient]);

  return null;
}

export default QueryWalletBackgroundObserver;
